
<script>
	import simplebar from "simplebar-vue";
	import axios from "axios";
	import SearchBar from "./forms/SearchBar.vue";

	/**
	 * Nav-bar Component
	 */

	export default {
		components: { simplebar, SearchBar },		
		beforeMount() {
			if(this.redirectRoute != null) {
				window.location.href = this.redirectRoute
			}
		},
		computed: {
			userType() {
				return this.$page.props.auth.user.user_type;
			},
			unreadNotifications() {
				return this.$page.props.auth.user.get_new_notifications;
			},
			userTypeAbbr() {
				return this.$page.props.auth.user.user_type_abbr;
			},
			isLockedAcc() {
				return this.$page.props.auth.user.is_it_locked_account;
			},
			isPaidAcc() {
				return this.$page.props.auth.user.login_user_is_paid;
			},
			isOeLogin() {
				return this.$page.props.auth.user.is_oe_login;
			},
			adminToUltraAdmin() {
				return this.$page.props.auth.user.admin_to_ultra_admin
			},
			adminToSb() {
				return this.$page.props.auth.user.admin_to_sb;
			},
			adminToTc() {
				return this.$page.props.auth.user.admin_to_tc;
			},
			epToTc() {
				return this.$page.props.auth.user.ep_to_tc;
			},
			tcToTp() {
				return this.$page.props.auth.user.tc_to_tp;
			},
			adminToTp() {
				return this.$page.props.auth.user.admin_to_tp;
			},
			allNotifications() {
				return this.$page.props.auth.user.all_notifications;
			},
			loginUserPhoto() {
				return this.$page.props.auth.user.login_user_photo;
			},
			nameWithWish() {
				return this.$page.props.auth.user.name_with_wish;
			},
			headerTaxSoftwareURL() {
				return this.$page.props.auth.user.header_tax_software_url;
			},
			headerTaxSoftwareResourceName() {
				return this.$page.props.auth.user.header_tax_software_resource_name;
			},
			headerStates() {
				return this.$page.props.auth.user.states;
			},
			redirectRoute() {
				return this.$page.props.auth.user.redirectRoute;
			},
			isUltraAdmin() {
				return this.$page.props.auth.user.is_ultra_admin
			}
		},
		data() {
			return {
				showWeatherCityChangeModal: false,
				submitedWeatherCityChange: false,
				commonCities: [],
				cityLoader: false,
				SearchValueRequired: true,
				isWeatherChangeLoading: false,
				readAllNotificationText: 'Read All',
				isreadAllNotificationLoading: false,
				globalSearchForm: {
					global_search: null,
				},
				responsiveGlobalSearchForm: {
					global_search: null,
				},
				changeWeatherCityForm: {
					state: null,
					city: null,
					platform: 'Vue'
				},
				weatherTemp: null,
				weatherCity: null,
				weatherLoading: true
			}
		},
		methods: {
			toggleMenu() {
				this.$parent.toggleMenu();
			},
			toggleRightSidebar() {
				this.$parent.toggleRightSidebar();
			},
			handleGlobalSearchsubmit() {
				this.$inertia.get(
					route('global-search-success-by-' + this.userTypeAbbr, [this.globalSearchForm.global_search]),
					{
						onError: (errors) => {
							if(errors.message) {
								this.$toastr.e(errors.message);
							}
						}
					}
				)
			},
			handleResponsiveGlobalSearchSubmit() {
				this.$inertia.post(
					route('global-search-by-' + this.userTypeAbbr),
					this.responsiveGlobalSearchForm,
						{
						onError: (errors) => {
							if(errors.message) {
								this.$toastr.e(errors.message);
							}
						}
					}
				)
			},
			manageWeather() {
				this.weatherLoading = true
				axios.get(
                    route(this.userTypeAbbr + '-get-weather'),
                    {}, {
                }).then(response => {
                    this.weatherTemp = response.data.weatherTemp
                    this.weatherCity = response.data.weatherCity
					this.weatherLoading = false
                }).catch(err => {
					this.weatherCity = 'Refresh'
					this.weatherLoading = false
                })
			},
			changeWeatherCity() {
				if(this.weatherTemp == null) {
					this.manageWeather()
				}
				this.changeWeatherCityForm.state = this.$page.props.auth.user.selected_state;
				this.changeWeatherCityForm.city = this.$page.props.auth.user.selected_city;
				this.showWeatherCityChangeModal = true;
				this.getCommonCities(this.$page.props.auth.user.selected_city);

			},
			handleWeatherCityChangeSubmit() {
				this.isWeatherChangeLoading = true;
				this.$inertia.post(
					route('weather_change_city_name'),
					this.changeWeatherCityForm,
					{
						onSuccess: (response) => {
							this.manageWeather()
							this.$toastr.s('Update Successfully');
							this.showWeatherCityChangeModal = false;
							this.isWeatherChangeLoading = false;
						},
						onError: (errors) => {
							this.isWeatherChangeLoading = false;
							if(errors.message) {
								this.$toastr.e(errors.message);
							}
						}
					}
				)
			},
			getCommonCities(str) {
				this.$Progress.start()
				let state_code = this.changeWeatherCityForm.state.split(':');
          		state_code = state_code[0];
				if(str == null) {
					this.changeWeatherCityForm.city = null;
				}
				this.cityLoader = true;
				axios.post(route('get_cities_for_vue'), {state_code: state_code}, {
                    })
                    .then(response => {
						this.commonCities = response.data;
						this.cityLoader = false;
                    })
                    .catch(err => {
                        
                    });
			},
			readAllNotifications() {
				this.readAllNotificationText = '<i class="bx bx-loader bx-spin font-size-16 align-middle me-2"></i> Loading';
				this.isreadAllNotificationLoading = true;
				axios.post(route('mark_all_notifications_as_read'), {
                    })
                    .then(response => {
						this.$page.props.auth.user.get_new_notifications = 0;
						this.readAllNotificationText = 'Read All';
						this.isreadAllNotificationLoading = false;
						this.$toastr.s('All notifications marked as read');
                    })
                    .catch(err => {
						this.readAllNotificationText = 'Read All';
						this.isreadAllNotificationLoading = false;
                        this.$toastr.e('Something went wrong, please try again!');
                    });
			},

			readSingleNotification(id, url) {
				this.$inertia.post(
					route('single-notification-seen'),
					{
                        "mydata" : {
                            notify_id: id,
							platform: 'Vue'
                        }
                    },
					{
						onSuccess: (response) => {
							if(decodeURIComponent(window.location.href) === url.substring(0, url.indexOf("#")) || decodeURIComponent(window.location.href) === url) {
								window.location.href = url;
								window.location.reload();
							} else {
								window.location.replace(url);
							}
						},
						onError: (errors) => {
							if(decodeURIComponent(window.location.href) === url.substring(0, url.indexOf("#")) || decodeURIComponent(window.location.href) === url) {
								window.location.href = url;
								window.location.reload();
							} else {
								window.location.replace(url);
							}
						}
					}
				)
			}
		},
		mounted() {
			this.manageWeather()
		}
	};
</script>

<template>	
	<header id="page-topbar">
		<div class="navbar-header">
			<div class="d-flex">
				<!-- LOGO -->
				<div class="navbar-brand-box">
					<Link :href="route('home_page')" class="logo logo-light">
						<span class="logo-sm">
						<img src="/public/new_design/images/main-logo.png" alt height="17" />
						</span>
						<span class="logo-lg">
						<img src="/public/new_design/images/seqwens_logo_fullwhite.png" alt height="22" />
						</span>
					</Link>
				</div>
				<button
					id="vertical-menu-btn"
					type="button"
					class="btn btn-sm px-3 font-size-16 header-item"
					@click="toggleMenu"
					>
					<i class="fa fa-fw fa-bars"></i>
				</button>
				
				<!-- App Search-->
				<form @submit.prevent class="app-search d-none d-lg-block" v-if="userType == 1 || userType == 2">
					<div class="position-relative">
						<SearchBar
							type="text"
							classes="form-control"
							name="global_search"
							placeholder="By Name, Email, Phone"
							:isRequired="SearchValueRequired"
							v-model="globalSearchForm.global_search"
							:searchInputTrigger="handleGlobalSearchsubmit"
						/>
						<span class="bx bx-search-alt"></span>
					</div>
				</form>
			</div>
			<div class="d-flex">
				<b-dropdown
					class="d-inline-block d-lg-none ms-2"
					variant="black"
					menu-class="dropdown-menu-lg p-0"
					toggle-class="header-item noti-icon"
					right
					v-if="userType == 1 || userType == 2"
				>
					<template v-slot:button-content>
						<i class="mdi mdi-magnify"></i>
					</template>

					<form @submit.prevent="handleResponsiveGlobalSearchSubmit" class="p-3">
						<div class="form-group m-0">
						<div class="input-group">
							<SearchBar
								type="text"
								classes="form-control"
								name="global_search"
								placeholder="By Name, Email, Phone"
								:isRequired="SearchValueRequired"
								v-model="responsiveGlobalSearchForm.global_search"
								:searchInputTrigger="handleResponsiveGlobalSearchSubmit"
							/>
							<div class="input-group-append">
							<button class="btn btn-primary" type="submit">
								<i class="mdi mdi-magnify"></i>
							</button>
							</div>
						</div>
						</div>
					</form>
				</b-dropdown>

				<div class="dropdown d-lg-inline-block ms-1" v-if="!isLockedAcc && userType != 4 && !isUltraAdmin">
					<a :href="route(userTypeAbbr + '-need-help')" title="Need Help">
						<button type="button" class="btn header-item noti-icon waves-effect weather-bttn-cast">
							<img src="/public/images/help_support.png" style="width: 27px;">
						</button>
					</a>
				</div>
				<div class="dropdown d-lg-inline-block ms-1">
					<button type="button" class="btn header-item waves-effect weather-bttn-cast" @click="changeWeatherCity">
						<strong>
							<span class="feels_like_symbol">
							<i class="bx bxs-cloud"></i>
								<i v-if="weatherLoading" class="bx bx-loader-alt bx-spin font-size-16 align-middle me-2"></i>
								<template v-else>
									{{ weatherTemp }}
								</template>
								℉
							</span>
						</strong>
						<span class="header-cloud-name">
							<strong>
								{{ weatherCity }}
							</strong>
						</span>
					</button>
				</div>
				<b-dropdown
					right
					menu-class="dropdown-menu-lg p-0 dropdown-menu-end"
					toggle-class="header-item noti-icon"
					variant="black"
					v-if="!isLockedAcc"
				>
					<template v-slot:button-content>
						<i class="bx bx-bell bx-tada"></i>
						<span v-if="unreadNotifications > 0" class="badge bg-danger rounded-pill"
						>{{unreadNotifications}}</span>
					</template>

					<div class="p-3">
						<div class="row align-items-center">
							<div class="col">
								<h6 class="m-0">Notifications</h6>
							</div>
							<div class="col-auto" v-if="unreadNotifications > 0">
								<a href="javascript:void(0);" class="small" @click="readAllNotifications" :disabled="isreadAllNotificationLoading" v-html="readAllNotificationText">
								</a>
							</div>
						</div>
					</div>
					<simplebar style="max-height: 230px;">
						<a v-for="data in allNotifications" href="javascript: void(0);" class="text-reset notification-item" :key="data.id" @click="readSingleNotification(data.id, data.full_url)">
							<div class="media">
								<div class="media-body">
									<h6 class="mt-0 mb-1">{{data.title}}</h6>
									<div class="font-size-12 text-muted">
										<p class="mb-0">
											<i class="mdi mdi-clock-outline"></i>
											{{data.time_ago}}
										</p>
									</div>
								</div>
							</div>
						</a>
					</simplebar>
					<div v-if="unreadNotifications > 0" class="p-2 border-top d-grid">
						<a class="btn btn-sm btn-link font-size-14 text-center" :href="route(userTypeAbbr + '-notification')">
							<i class="mdi mdi-arrow-down-circle me-1"></i>
							<span key="t-view-more"> View More.. </span>
						</a>
					</div>
				</b-dropdown>

				<div class="dropdown d-none d-sm-inline-block ms-1" v-if="userType != 4">
					<a target="_blank" :href="headerTaxSoftwareURL">
						<button type="button" class="btn btn-success w-lg waves-effect waves-light mt-3">
							{{headerTaxSoftwareResourceName}}
						</button>
					</a>
				</div>

				<b-dropdown right variant="black" toggle-class="header-item" menu-class="dropdown-menu-end">
					<template v-slot:button-content>
						<img
							class="rounded-circle header-profile-user"
							:src="loginUserPhoto"
							alt="Header Avatar"
						/>
						<span class="d-none d-xl-inline-block ms-1">{{nameWithWish}}</span>
						<i class="mdi mdi-chevron-down d-none d-xl-inline-block"></i>
					</template>
					<!-- item-->
					<template v-if="!isLockedAcc && isPaidAcc">
						<b-dropdown-item v-if="userTypeAbbr == 'tp'" :href="route(userTypeAbbr + '-profile-edit')">
							<i class="bx bx-user font-size-16 align-middle me-1"></i>
							Profile
						</b-dropdown-item>
						<b-dropdown-item v-else :href="route(userTypeAbbr + '-profile')">
							<i class="bx bx-user font-size-16 align-middle me-1"></i>
							Profile
						</b-dropdown-item>
					</template>
				
					<b-dropdown-item :href="route(userTypeAbbr + '-billing')" v-if="!isOeLogin && (userType == 2 || userType == 3)">
						<i class="bx bx-wallet font-size-16 align-middle me-1"></i>
						Payment
					</b-dropdown-item>
					<template v-if="userType == 1">
						<b-dropdown-item :href="route('admin-move-back-to-employer')" v-if="isOeLogin">
							<i class="bx bx-arrow-back font-size-16 align-middle me-1"></i>
							Back to Employer
						</b-dropdown-item>
						<b-dropdown-item :href="route('ultra-admin-move-back-to-admin')" v-if="adminToUltraAdmin">
							<i class="bx bx-arrow-back font-size-16 align-middle me-1"></i>
							Back to Admin
						</b-dropdown-item>
					</template>
					<template v-if="userType == 2">
						<b-dropdown-item :href="route('sb-move-back-to-employer')" v-if="isOeLogin">
							<i class="bx bx-arrow-back font-size-16 align-middle me-1"></i>
							Back to Employer
						</b-dropdown-item>
						<b-dropdown-item :href="route('move-sb-to-admin')" v-if="adminToSb">
							<i class="bx bx-arrow-back font-size-16 align-middle me-1"></i>
							Back to Admin
						</b-dropdown-item>
					</template>
					<template v-if="userType == 3">
						<b-dropdown-item :href="route('tc-move-back-to-employer')" v-if="isOeLogin">
							<i class="bx bx-arrow-back font-size-16 align-middle me-1"></i>
							Back to Employer
						</b-dropdown-item>
						<b-dropdown-item :href="route('move-tc-to-admin')" v-if="adminToTc">
							<i class="bx bx-arrow-back font-size-16 align-middle me-1"></i>
							Back to Admin
						</b-dropdown-item>
						<b-dropdown-item :href="route('move-tc-to-ep')" v-if="epToTc">
							<i class="bx bx-arrow-back font-size-16 align-middle me-1"></i>
							Back to Enterprise Partner
						</b-dropdown-item>
					</template>
					<template v-if="userType == 4">
						<b-dropdown-item :href="route('move-tp-to-tc')" v-if="tcToTp">
							<i class="bx bx-arrow-back font-size-16 align-middle me-1"></i>
							Back to Tax Company
						</b-dropdown-item>
						<b-dropdown-item :href="route('move-tp-to-admin')" v-if="adminToTp">
							<i class="bx bx-arrow-back font-size-16 align-middle me-1"></i>
							Back to Admin
						</b-dropdown-item>
					</template>
					<b-dropdown-divider></b-dropdown-divider>
					<a :href="route('session-logout')" class="dropdown-item text-danger">
						<i class="bx bx-power-off font-size-16 align-middle me-1 text-danger"></i>
						Logout
					</a>
				</b-dropdown>
			</div>
		</div>
		<b-modal v-model="showWeatherCityChangeModal" hide-footer centered header-class="border-0" title="To Get Current Weather, Update City & State">
			<form @submit.prevent="handleWeatherCityChangeSubmit">
				<div class="row">
					<div class="col-12">
						<div class="mb-3">
						<label for="state">State</label>
						<b-form-select v-model="changeWeatherCityForm.state" class="form-control" id="state" name="state" :class="{'is-invalid': $page.props.errors.state}" @change="getCommonCities(null)">
							<b-form-select-option :value="null">Please select state</b-form-select-option>
							<b-form-select-option v-for="data of headerStates" :value="data.state_code + ':' + data.name" :key="data._id">
								{{ data.name }}
							</b-form-select-option>
						</b-form-select>
						<div
							v-if="$page.props.errors.state"
							class="invalid-feedback"
						>
							{{$page.props.errors.state}}
						</div>
						</div>
					</div>
					<div v-if="cityLoader" class="spinner-border text-success m-3" role="status">
                        <span class="sr-only">Loading...</span>
                    </div>
					<div v-else class="col-12">
						<div class="mb-3">
						<label for="city">City</label>
						<b-form-select v-model="changeWeatherCityForm.city" class="form-control" id="city" name="city" :class="{'is-invalid': $page.props.errors.city}">
							<b-form-select-option :value="null">Please select city</b-form-select-option>
							<b-form-select-option v-for="(item, index) in this.commonCities.data" :value="item.name" :key="index">
								{{ item.name }}
							</b-form-select-option>
						</b-form-select>
						<div
								v-if="$page.props.errors.city"
								class="invalid-feedback"
							>
								{{$page.props.errors.city}}
							</div>
						</div>
					</div>
					<div class="text-end mt-3">
					<b-button variant="light" @click="showWeatherCityChangeModal = false">Close</b-button>
					<b-button type="submit" variant="success" class="ms-1" :disabled="isWeatherChangeLoading" v-if="!isWeatherChangeLoading">
						Update
					</b-button>
					<b-button type="button" class="ms-1" v-else :disabled="isWeatherChangeLoading">
                        <i class="bx bx-loader bx-spin font-size-16 align-middle me-2"></i> Loading
                    </b-button>
					</div>
				</div>
			</form>
		</b-modal>
	</header>
</template>
